import { BasePaymentProviderReturn } from "./usePayment";

// This is a hook which implements the interface for payment but does
// not actually make any payment. It is used for refunds.
const useRefundPayment = (): BasePaymentProviderReturn => {
  const makePayment = async () => {
    // There is no payment to be made so it is set as empty
    return { paymentId: "" };
  };

  return {
    capturingPayment: false,
    succeededPaymentIntentId: "",
    makePayment,
    isPaymentConfigurationError: false,
    eligiblePaymentProvider: "",
  };
};

export default useRefundPayment;
